module.exports = __webpack_public_path__ + "static/media/card-turaanadaa.8a66656a.png";